import React from 'react';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Source } from './devActivity';
import shared from './SystemHealthPage.module.scss';

/** "Loading", "Unavailable", "Stale" (real data, latest update failed) or "Live" pill for a card or tile header. */
export const SourceBadge: React.FC<{ source: Source<unknown> }> = ({ source }) =>
    source.loading ? (
        <span className={`${shared.loadingBadge} ${shared.pulse}`}>Loading</span>
    ) : source.data == null ? (
        <span className={shared.errorBadge} title={source.error ?? undefined}>
            Unavailable
        </span>
    ) : source.stale ? (
        <span className={shared.staleBadge} title="The latest update failed; this is from an earlier one">
            Stale
        </span>
    ) : (
        <span className={shared.liveBadge}>Live</span>
    );

/** Card body for a source: a spinner until its first answer, why it failed if it never answered, else the content. */
export function Loaded<T>({ source, children }: { source: Source<T>; children: (data: T) => React.ReactNode }) {
    if (source.data != null) return <>{children(source.data)}</>;
    if (source.loading) return <LoadingIndicator />;
    return <p className={shared.muted}>Could not load: {source.error}</p>;
}
